import React from 'react';
interface ArticleCardProps {
  title: string;
  category: string;
  date: string;
  author: string;
  imageUrl: string;
  imageClassName?: string;
}
export function ArticleCard({
  title,
  category,
  date,
  author,
  imageUrl,
  imageClassName = 'w-32 h-24'
}: ArticleCardProps) {
  return <div className="flex gap-4 group cursor-pointer" data-id="element-20" data-mp="19zftoru01lha">
      <img src={imageUrl} alt={title} className={`${imageClassName} object-cover flex-shrink-0`} data-id="element-21" data-mp="19ynz9kc51tsl" />
      <div className="flex flex-col justify-start" data-id="element-22" data-mp="10y9agazytwkc">
        <h3 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors" data-id="element-23" data-mp="10woeqi1x07kw">
          {title}
        </h3>
        <div className="text-xs mt-2" data-id="element-24" data-mp="r0bnrrxr87tu">
          <span className="text-[#002f5f] hover:underline" data-id="element-25" data-mp="r1d8ko4ko8or">{category}</span>
          <div className="text-gray-500 mt-1" data-id="element-26" data-mp="2qdfqhtxjsv0b">
            {date}{' '}
            <span className="ml-2" data-id="element-27" data-mp="2le32v6yurjwo">
              By{' '}
              <span className="text-[#002f5f] hover:underline" data-id="element-28" data-mp="2lemb1vypatxi">{author}</span>
            </span>
          </div>
        </div>
      </div>
    </div>;
}